/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import {
  Component,
  Input,
  Output,
  EventEmitter,
  ContentChild,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'xrx-radio',
  templateUrl: './xrx-radio.component.html',
  styleUrls: ['./xrx-radio.component.less'],
  standalone: false,
})
export class XrxRadioComponent {
  @Input() id = '';
  @Input() list: radioListType[];
  @Input() property: string;
  @Input() localize: string;
  @Input() checkedItem: any;
  @Input() desc: string;
  @Input() display: string;

  @Output() checkedItemChange = new EventEmitter<any>();
  @Output() change = new EventEmitter<any>();

  @ContentChild('xrxRadioContent', { static: false })
  xrxRadioTemplateRef: TemplateRef<any>;

  onChecked(item: radioListType) {
    if (this.checkedItem != item) {
      this.checkedItem = item;
      this.checkedItemChange.emit(this.checkedItem);
      this.change.emit(this.checkedItem);
    }
  }
  getPropertyString(
    type: 'localize' | 'property' | 'desc',
    item?: radioListType,
  ): string {
    if (item) {
      if (type === 'localize') {
        const propertyString = item[this.localize as keyof typeof item];
        return propertyString as string;
      } else if (type === 'property') {
        const propertyString = item[this.property as keyof typeof item];
        return propertyString as string;
      } else if (type === 'desc') {
        const propertyString = item[this.desc as keyof typeof item];
        return propertyString as string;
      }
    }
    return '';
  }
}

export interface radioListType {
  isChecked: boolean;
  value: string | number | boolean;
  display?: string;
  disabled?: boolean;
}
